import React from "react";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

const WebInProgress = ({ badge = "USKORO", message, socials }) => {
  return (
    <div className="fucascore-maintenance">
      <div className="maintenance-glass-card">
        {/* Pozadinski sjaj */}
        <div className="maintenance-glow"></div>

        {/* Logo / Badge */}
        <div className="maintenance-brand">
          <img
            className="maintenance-logo-badge"
            src={FucaScoreLogo}
            alt="FucaScore Logo"
          />
          <h1 className="maintenance-app-title">FucaScore</h1>
        </div>

        {/* Status Badge */}
        <div className="maintenance-status-badge">
          <span className="pulse-dot"></span>
          <span>{badge || "USKORO"}</span>
        </div>

        {/* Glavni sadržaj */}
        <div className="maintenance-content">
          <p className="maintenance-desc">
            {message ||
              "Aplikacija za praćenje malonogometnih turnira uživo, rasporeda, tablica i statistike u stvarnom vremenu!"}
          </p>
        </div>

        {/* Društvene mreže (ako postoje) */}
        {socials &&
          (socials.facebook || socials.instagram || socials.tiktok) && (
            <div className="maintenance-socials">
              <span className="socials-label">Pratite nas:</span>
              <div className="socials-list">
                {socials.instagram && (
                  <a
                    href={socials.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon instagram"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                )}
                {socials.facebook && (
                  <a
                    href={socials.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon facebook"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                )}
                {socials.tiktok && (
                  <a
                    href={socials.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon tiktok"
                  >
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default WebInProgress;
